import { IShareLinkMapped, ISharedLink } from './shareLink.model';

export const mapShareLinkFromApiToVm = (
  link: ISharedLink,
): IShareLinkMapped => ({
  id: link.id,
  entityId: link.entity_id,
  entityType: link.entity_type,
  token: link.token,
  isEmailRequired: link.is_email_required,
  isPasswordRequired: link.is_password_required,
  options: {
    hideAudienceFilters: link.options.hide_audience_filters,
    category: link.options.category,
    view: link.options.view,
  },
  notifications: link.notifications?.map((notification) => ({
    id: notification.id,
    notificationType: notification.notification_type,
    shareLinkId: notification.share_link_id,
    userId: notification.user_id,
    userType: notification.user_type,
  })),
});
